<template>
	<div id="default">
		<section class="app-body-footer">
			<transition name="fade" mode="out-in">
				<router-view/>
			</transition>
		</section>
		<footer>
			<div class="footer-nav" :class="{'active':active == 'index'}" @click="goPage('index')">
				<i class="nav-index"></i><br />
				<span>首页</span>
			</div>
			<div class="footer-nav" :class="{'active':active == 'market'}" @click="goPage('market')">
				<i class="nav-market"></i><br />
				<span>市场</span>
			</div>
			<div class="footer-nav" :class="{'active':active == 'order'}" @click="goPage('order')">
				<i class="nav-order"></i><br />
				<span>订单</span>
			</div>
			<div class="footer-nav" :class="{'active':active == 'wallet'}" @click="goPage('wallet')">
				<i class="nav-wallet"></i><br />
				<span>钱包</span>
			</div>
			<div class="footer-nav" :class="{'active':active == 'mine'}" @click="goPage('mine')">
				<i class="nav-mine"></i><br />
				<span>我的</span>
			</div>
		</footer>
	</div>
</template>

<script>
import { debuglog } from 'util';
	export default {
		name: 'default',
		data() {
			return {
				active: null
			}
		},
		methods: {
			goPage(name) {
				this.active = name
				this.$store.commit('setParam',{
		          	name:'menu',
		          	prop:'active',
		          	value:this.active
		        })
				this.$router.push({name:name})
			}
		},
		created() {
			this.active = this.$store.state.routerStore.menu.active;
		}
		
	}
</script>

<style lang="less" scoped>
	footer {
		position: fixed;
		z-index: 99;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		height: 54px;
		padding-top:5px;
		background: #1c2238;
		.footer-nav{
			flex: 1;
			text-align: center;
			color:#7b91d1;
			i{
				display: inline-block;
				width: 25px;
				height: 26px;
				background: url(../assets/images/icons.png) no-repeat;
				background-size: 650%;
				&.nav-index{
					background-position: -10px -10px;
				}
				&.nav-market{
					background-position: -10px -353px;
				}
				&.nav-order{
					background-position: -10px -79px;
				}
				&.nav-wallet{
					background-position: -10px -146px;
				}
				&.nav-mine{
					background-position: -10px -216px;
				}
			}
			span{
				font-size:12px!important;
			}
			&.active{
				color:#569eff;
				i{
					&.nav-index{
						background-position: -10px -45px;
					}
					&.nav-market{
						background-position: -10px -387px;
					}
					&.nav-order{
						background-position: -10px -113px;
					}
					&.nav-wallet{
						background-position: -10px -180px;
					}
					&.nav-mine{
						background-position: -10px -250px;
					}
				}
			}
		}
	}
</style>